import React from 'react';
import { motion } from 'framer-motion';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  image?: string;
  imageAlt?: string;
  centered?: boolean;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  image,
  imageAlt = 'Header image',
  centered = true,
}) => {
  const containerStyles = image
    ? 'bg-primary text-white relative min-h-[400px] md:min-h-[500px] overflow-hidden pt-24 md:pt-32'
    : 'bg-primary text-white relative py-24 md:py-32 pt-24 md:pt-32';

  return (
    <div className={containerStyles}>
      {image && (
        <div className="absolute inset-0">
          <img
            src={image}
            alt={imageAlt}
            className="w-full h-full object-cover opacity-30"
          />
        </div>
      )}
      <div className="container mx-auto px-4 relative z-10 h-full flex flex-col justify-center">
        <div className={`max-w-3xl ${centered ? 'mx-auto text-center' : ''}`}>
          <motion.h1
            className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold font-display mb-4"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            {title}
          </motion.h1>
          {subtitle && (
            <motion.p
              className="text-base md:text-lg text-white/90 max-w-2xl mx-auto"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              {subtitle}
            </motion.p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;